import styled from '@mui/material/styles/styled';

export const Input = styled('input')({ display: 'none' });